const LOCALES = [
  { locale: 'es', match: /es/, label: 'Español' },
  { locale: 'pt', match: /pt/, label: 'Português' },
  { locale: 'en', match: /en/, label: 'English' },
]

export default LOCALES
